import {http} from './config/config-relation-register'
export default{
    listar:(token)=>{
        return http.get('classes-uso',{
            headers:{
                'Authorization':token
            }
        })
    },
}